import { useEffect } from 'react';
import { useBlocker } from 'react-router';
import { t } from '../../i18next';

export const useLeavePageConfirmation = (props) => {
  const { shouldPreventLeaving } = props;
  const blocker = useBlocker(shouldPreventLeaving);

  useEffect(() => {
    if (shouldPreventLeaving) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }

    return () => {
      window.onbeforeunload = undefined;
    };
  }, [shouldPreventLeaving]);

  if (blocker.state === 'blocked') {
    const confirmed = window.confirm(t('changes_not_saved'));
    if (confirmed) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }
};
